var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrangeExclamation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FFEDE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8629 9.60962H21.9019L21.4602 24.1564H18.2731L17.8629 9.60962ZM19.8824 31.6096C19.1251 31.6096 18.5045 31.3699 18.0207 30.8905C17.5368 30.411 17.2949 29.8008 17.2949 29.0598C17.2949 28.3189 17.5368 27.6978 18.0207 27.1965C18.5045 26.6953 19.1251 26.4447 19.8824 26.4447C20.6397 26.4447 21.2708 26.6953 21.7757 27.1965C22.2806 27.6978 22.533 28.3189 22.533 29.0598C22.533 29.8008 22.2806 30.411 21.7757 30.8905C21.2708 31.3699 20.6397 31.6096 19.8824 31.6096Z",
    fill: "#FFA37F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeExclamation);
export default __webpack_public_path__ + "static/media/orange-exclamation.822fd37d.svg";
export { ForwardRef as ReactComponent };